// removed by extract-text-webpack-plugin
module.exports = {"container":"_29ypqGRFwW9wwhRaq12vY3","card":"_3HQYIEycIpzXdAaNvUmNbZ","webpackInfo":"E9NAVzpqzVbJ3h68olqSf","warningsErrors":"_1-t7SEUyD6cpkk9FZJ2Ch5","modules":"T0Y5akaiLS6Jp0gRIiW9F","content":"_2wsG6g2guI8a0IP2194MWb"};


//////////////////
// WEBPACK FOOTER
// ./styles/base.css
// module id = 166
// module chunks = 0